import { focusVisible } from "@mittwald/flow-styles/dist/mixins/focusVisible";
import { color, duration, size, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import boxMixin from "../../../mixins/box";
import { NavigationItemIcon } from "./NavigationItemIcon";
import { NavigationItemText } from "./NavigationItemText";
import isPropValid from "@emotion/is-prop-valid";
export const NavigationItemContainer = styled.a.withConfig({
    shouldForwardProp: isPropValid,
}) `
  ${boxMixin};
  border-radius: ${size.borderRadius};
  cursor: pointer;
  transition:
    background ${duration.animation.moderate}ms,
    color ${duration.animation.moderate}ms;

  ${NavigationItemText} {
    color: ${color.font.text.default};
  }

  ${NavigationItemIcon} {
    transition: color ${duration.animation.moderate}ms;
    color: ${color.font.label.default};
  }

  &:not(.disabled) {
    &:hover,
    &.hover {
      background: ${color.background.selectableBox.hovered};
    }

    &.busy {
      background: ${color.background.selectableBox.selected};

      ${NavigationItemText}, ${NavigationItemIcon} {
        color: ${color.font.link.disabled};
      }
    }

    &.active {
      background: ${color.background.selectableBox.selected};

      ${NavigationItemText},
      ${NavigationItemIcon} {
        font-weight: bold;
        color: ${color.font.link.default};
      }
    }

    &.inverse {
      &:not(.busy) {
        ${NavigationItemText},
        ${NavigationItemIcon} {
          color: ${color.font.text.inverse.default};
        }
      }

      &:hover,
      &.hover,
      &:active,
      &.busy,
      &.active {
        background: ${color.brand.primary.default};
      }
    }
  }

  ${focusVisible}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTmF2aWdhdGlvbkl0ZW1Db250YWluZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9OYXZpZ2F0aW9uL3N0eWxlZC9OYXZpZ2F0aW9uSXRlbUNvbnRhaW5lci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsWUFBWSxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDOUUsT0FBTyxFQUNMLEtBQUssRUFDTCxRQUFRLEVBQ1IsSUFBSSxHQUNMLE1BQU0sZ0RBQWdELENBQUM7QUFDeEQsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxRQUEyQixNQUFNLHFCQUFxQixDQUFDO0FBQzlELE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQzFELE9BQU8sRUFBRSxrQkFBa0IsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQzFELE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBRWpELE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLE1BQU0sQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDO0lBQ3pELGlCQUFpQixFQUFFLFdBQVc7Q0FDL0IsQ0FBQyxDQUFlO0lBQ2IsUUFBUTttQkFDTyxJQUFJLENBQUMsWUFBWTs7O2lCQUduQixRQUFRLENBQUMsU0FBUyxDQUFDLFFBQVE7WUFDaEMsUUFBUSxDQUFDLFNBQVMsQ0FBQyxRQUFROztJQUVuQyxrQkFBa0I7YUFDVCxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPOzs7SUFHaEMsa0JBQWtCO3dCQUNFLFFBQVEsQ0FBQyxTQUFTLENBQUMsUUFBUTthQUN0QyxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxPQUFPOzs7Ozs7b0JBTWpCLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLE9BQU87Ozs7b0JBSXRDLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLFFBQVE7O1FBRW5ELGtCQUFrQixLQUFLLGtCQUFrQjtpQkFDaEMsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsUUFBUTs7Ozs7b0JBS3JCLEtBQUssQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLFFBQVE7O1FBRW5ELGtCQUFrQjtRQUNsQixrQkFBa0I7O2lCQUVULEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU87Ozs7OztVQU05QixrQkFBa0I7VUFDbEIsa0JBQWtCO21CQUNULEtBQUssQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPOzs7Ozs7Ozs7c0JBUzVCLEtBQUssQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLE9BQU87Ozs7O0lBSzdDLFlBQVk7Q0FDZixDQUFDIn0=